import {
  Select,
  MenuItem,
  TextField,
  Chip,
  Box,
  Typography,
} from "@mui/material";

export default function ParticipantRow({ participant, onChange }) {
  const { type, participant_data, candidates, researcher } = participant;

  // -------------------------
  // AUTO
  // -------------------------
  if (type === "auto") {
    return (
      <Box
        sx={{
          p: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #eee",
        }}
      >
        <Box sx={{ display: "flex", gap: 1, alignItems: "baseline" }}>
          <Typography variant="body2">
            {researcher.name} {researcher.surname}
          </Typography>

          <Typography variant="caption" color="text.secondary">
            {researcher.institution?.name || ""}
          </Typography>
        </Box>
      </Box>
    );
  }

  // -------------------------
  // HUMAN
  // -------------------------
  if (type === "human") {
    return (
      <Box
        sx={{
          p: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #eee",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2">
            {participant_data.name} {participant_data.familyname}
          </Typography>

          <Select
            fullWidth
            size="small"
            sx={{ minWidth: 220 }}
            onChange={(e) =>
              onChange({
                type: "human",
                selectedId: e.target.value,
              })
            }
          >
            {candidates.map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.name} {c.surname}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>
    );
  }

  // -------------------------
  // EXTERNAL
  // -------------------------
  return (
    <Box
      sx={{
        p: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid #eee",
      }}
    >
      <Box sx={{ display: "flex", gap: 1, alignItems: "baseline" }}>
        <Typography variant="body2">
          {participant_data.name} {participant_data.familyname}
        </Typography>

        <Typography variant="caption" color="text.secondary">
          {`(${participant_data.institution})` || "—"}
        </Typography>
      </Box>
    </Box>
  );
}
